"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const socket_io_client_1 = __importDefault(require("socket.io-client"));
class SocketClient {
    constructor({ host, }, type) {
        this.connection = null;
        this.type = type;
        this.init(host);
    }
    init(host) {
        if (host !== '') {
            this.connection = (0, socket_io_client_1.default)(host);
            this.connection.on('connect', () => {
                if (this.connection !== null) {
                    console.info('Socket new connection', this.connection.id);
                }
            });
            this.connection.on('connect_error', (err) => {
                const error = err;
                if (error) {
                    console.info('Socket connection failed', error.message);
                }
            });
        }
    }
    on({ action, type, }) {
        if (this.connection !== null) {
            this.connection.on(type, action);
        }
    }
    off({ action, type, }) {
        if (this.connection !== null) {
            this.connection.removeListener(type, action);
        }
    }
}
exports.default = SocketClient;
